import { forwardRef } from 'react';
import invariant from 'tiny-invariant';
import { Box, BoxProps } from '../Box/Box';

export type DividerProps = {
  orientation?: 'horizontal' | 'vertical';
  contentPosition?: 'start' | 'end';
} & Pick<
  BoxProps,
  | 'margin'
  | 'marginRight'
  | 'marginLeft'
  | 'marginTop'
  | 'marginBottom'
  | 'm'
  | 'mr'
  | 'ml'
  | 'mt'
  | 'mb'
  | 'color'
  | 'role'
  | 'children'
>;

export const Divider = forwardRef<HTMLDivElement, DividerProps>(
  (
    {
      orientation = 'horizontal',
      contentPosition,
      color,
      role,
      children,
      ...rest
    },
    ref
  ) => {
    invariant(
      role !== 'separator' || !children,
      'Семантический разделитель не может принимать children'
    );

    const lineStyle = {
      content: "''",
      borderBottom: Number(orientation === 'horizontal'),
      borderLeft: Number(orientation === 'vertical'),
      borderColor: color ?? 'dividerBorderColor',
    };

    return (
      <Box
        ref={ref}
        {...rest}
        display="flex"
        flexDirection={orientation === 'horizontal' ? 'row' : 'column'}
        alignItems="center"
        alignContent="center"
        alignSelf="stretch"
        styles={{
          gap: children ? 'sp-12' : 0,
          '::before, ::after': {
            display: 'block',
            flex: 1,
          },
          '::before': {
            ...(contentPosition !== 'start' && lineStyle),
          },
          '::after': {
            ...(contentPosition !== 'end' && lineStyle),
          },
        }}
      >
        {children}
      </Box>
    );
  }
);
